var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"hp-authentication-page"},[_c('left-item'),(_vm.slide == 1)?_c('Slide1',{on:{"nextSlide":function($event){_vm.slide++}}}):(_vm.slide == 2)?_c('Slide2',{attrs:{"errorMessage":_vm.errorMessage},on:{"nextSlide":function($event){return _vm.register()},"prevSlide":function($event){_vm.slide--}}}):_c('Congrats')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }